import api from "./api";

export const workspaceOverview = () => api.get("/ujms/workspace/overview");
export const courtHome = (day) => api.get("/ujms/workspace/home", { params: { day } });
export const workspacePreferences = () => api.get("/ujms/workspace/preferences");
export const setWorkingCase = (case_id) => api.put("/ujms/workspace/context", { case_id });
export const saveShortcuts = (shortcuts) => api.put("/ujms/workspace/shortcuts", { shortcuts });
export const staffNotices = () => api.get("/ujms/workspace/notices");
export const publishNotice = (data) => api.post("/ujms/workspace/notices", data);
export const updateNotice = (id, data) => api.put(`/ujms/workspace/notices/${id}`, data);
export const deleteNotice = (id) => api.delete(`/ujms/workspace/notices/${id}`);
export const savedSearches = () => api.get("/ujms/workspace/searches");
export const saveSearch = (data) => api.post("/ujms/workspace/searches", data);
export const editSearch = (id, data) => api.put(`/ujms/workspace/searches/${id}`, data);
export const removeSearch = (id) => api.delete(`/ujms/workspace/searches/${id}`);
export const runSearch = (id) => api.post(`/ujms/workspace/searches/${id}/run`);
export const calculateDate = (data) => api.post("/ujms/tools/date-calculator", data);
export const calculateInterest = (data) => api.post("/ujms/tools/interest-calculator", data);
export const searchUrl = (filters) => {
  const sp = new URLSearchParams();
  if (filters.q) sp.set("q", filters.q);
  if (filters.case_type) sp.set("type", filters.case_type);
  if (filters.status) sp.set("status", filters.status);
  if (filters.sort) sp.set("sort", filters.sort);
  if (filters.direction) sp.set("dir", filters.direction);
  return `/ujms/cases?${sp}`;
};